import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nameInput", "warningContainer"]
  static values = { 
    checkUrl: String,
    excludeId: Number
  }

  connect() {
    this.timeout = null
  }

  checkForDuplicates() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(() => {
      this.performCheck()
    }, 300) // 300ms delay
  }

  async performCheck() {
    const name = this.nameInputTarget.value.trim()
    
    if (name.length < 2) {
      this.hideWarning()
      return
    }

    try {
      const params = new URLSearchParams({
        name: name
      })
      
      if (this.excludeIdValue) {
        params.append('exclude_id', this.excludeIdValue)
      }

      const url = `${this.checkUrlValue}?${params}`

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      
      if (data.duplicates && data.duplicates.length > 0) {
        this.showWarning(data.duplicates)
      } else {
        this.hideWarning()
      }
    } catch (error) {
      console.error('Fehler beim Prüfen auf Duplikate:', error)
      this.hideWarning()
    }
  }

  showWarning(duplicates) {
    if (!this.hasWarningContainerTarget) {
      return
    }

    this.warningContainerTarget.innerHTML = `
      <div class="bg-yellow-50 border border-yellow-200 rounded-md p-4 mb-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="ml-3">
            <h3 class="text-sm font-medium text-yellow-800">
              ⚠️ Mögliche Duplikate gefunden
            </h3>
            <div class="mt-2 text-sm text-yellow-700">
              <p>Es wurden bereits Kunden mit diesem Namen gefunden:</p>
              <ul class="mt-2 space-y-1">
                ${duplicates.map(dup => `
                  <li class="flex items-center">
                    <a href="${dup.url}" target="_blank" class="text-yellow-800 hover:text-yellow-900 underline">
                      ${dup.name} ${dup.city ? `(${dup.city})` : ''}
                    </a>
                  </li>
                `).join('')}
              </ul>
              <p class="mt-2 text-xs">
                Bitte überprüfen Sie, ob es sich um denselben Kunden handelt.
              </p>
            </div>
          </div>
        </div>
      </div>
    `
    
    this.warningContainerTarget.style.display = 'block'
  }

  hideWarning() {
    if (this.hasWarningContainerTarget) {
      this.warningContainerTarget.style.display = 'none'
      this.warningContainerTarget.innerHTML = ''
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
}
